export const ROOT = '/*';
export const DASHBOARD = '/dashboard';
export const MEDIA = '/media-management';
export const ADMIN_PANEL = '/admin-panel';
export const MACHINE_GROUP_DETAILS = '/machine-group/:id';
export const UNAUTHORIZED = '/unauthorized';
